// extracted by mini-css-extract-plugin
export default {"svgiconblog":"b4eeffd5676eea6d44cd","subtitle":"e5cc9ef94685a3429fc4","sendbtncontainer":"a1b80d0bdf074d8261b6"};